import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { fadeInUp, staggerContainer, slideInLeft, slideInRight } from '../lib/animations';
const stats = [{
  label: 'Years Experience',
  value: '25+'
}, {
  label: 'Countries Exported',
  value: '12+'
}, {
  label: 'Monthly Capacity',
  value: '50k+'
}, {
  label: 'Happy Clients',
  value: '500+'
}];
export function About() {
  return <section id="about" className="py-24 md:py-32 bg-[#f9fafb] overflow-hidden" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24" data-id="element-3">
          {/* Image Side */}
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={slideInLeft} className="w-full lg:w-1/2 relative" data-id="element-4">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl aspect-[3/4] max-w-md mx-auto" data-id="element-5">
              <img src="https://cdn.magicpatterns.com/uploads/gASL1CgwMcDZ6phYkrDmfM/Gemini_Generated_Image_9ypc3p9ypc3p9ypc.png" alt="Aditya Darak - Founder" className="w-full h-full object-cover" data-id="element-6" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1e3a8a]/80 to-transparent" data-id="element-7"></div>
              <div className="absolute bottom-8 left-8 text-white max-w-xs" data-id="element-8">
                <p className="font-bold text-2xl mb-1" data-id="element-9">Aditya Darak</p>
                <p className="text-sm opacity-80 uppercase tracking-wider" data-id="element-10">
                  Founder, Shivaay Fashion
                </p>
              </div>
            </div>
            {/* Decorative Elements */}
            <div className="absolute -bottom-10 -right-10 w-40 h-40 bg-[#dc2626]/10 rounded-full blur-3xl -z-10" data-id="element-11"></div>
            <div className="absolute -top-10 -left-10 w-40 h-40 bg-[#1e3a8a]/10 rounded-full blur-3xl -z-10" data-id="element-12"></div>
          </motion.div>

          {/* Content Side */}
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={staggerContainer} className="w-full lg:w-1/2" data-id="element-13">
            <motion.span variants={fadeInUp} className="text-[#dc2626] font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-14">
              About Us
            </motion.span>
            <motion.h2 variants={fadeInUp} className="text-4xl md:text-5xl font-bold text-[#1e3a8a] mb-8 leading-tight" data-id="element-15">
              Crafting Legacy Through <br data-id="element-16" /> Every Thread
            </motion.h2>

            <motion.div variants={fadeInUp} className="space-y-6 text-lg text-gray-600 mb-10" data-id="element-17">
              <p data-id="element-18">
                At Shivaay Fashion (Shree Shivaay Creations), we don't just
                manufacture textiles; we engineer comfort and style. Under the
                visionary leadership of <strong data-id="element-19">Aditya Darak</strong>, we have
                evolved from a local trading house to a global export
                powerhouse.
              </p>
              <p data-id="element-20">
                Located in the heart of Mumbai's textile district, our facility
                combines age-old weaving traditions with state-of-the-art
                machinery to produce fabrics that meet the highest international
                standards.
              </p>
            </motion.div>

            <motion.div variants={staggerContainer} className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12" data-id="element-21">
              {['Premium Quality Assurance', 'Global Export Logistics', 'Sustainable Manufacturing', 'Custom Fabric Development'].map((item, index) => <motion.div key={index} variants={fadeInUp} className="flex items-center space-x-3 group" data-id="element-22">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center group-hover:bg-[#1e3a8a] transition-colors duration-300" data-id="element-23">
                    <Check className="w-3.5 h-3.5 text-[#1e3a8a] group-hover:text-white transition-colors duration-300" data-id="element-24" />
                  </div>
                  <span className="text-gray-700 font-medium" data-id="element-25">{item}</span>
                </motion.div>)}
            </motion.div>

            <motion.div variants={staggerContainer} className="grid grid-cols-2 sm:grid-cols-4 gap-8 border-t border-gray-200 pt-8" data-id="element-26">
              {stats.map((stat, index) => <motion.div key={index} variants={fadeInUp} data-id="element-27">
                  <p className="text-3xl font-bold text-[#1e3a8a] mb-1" data-id="element-28">
                    {stat.value}
                  </p>
                  <p className="text-xs text-gray-500 uppercase tracking-wide" data-id="element-29">
                    {stat.label}
                  </p>
                </motion.div>)}
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}